import { useI18n } from "../../lib/i18n";

/**
 * Bakiye göstergesi: sayı ve cümle asıl bilgidir; çubuk yalnızca görsel destek (aria-hidden).
 * Kullanılabilir (dolu) ve onay bekleyen (taralı) ayrı gösterilir.
 */
export function BalanceMeter({ available, pending, unit = "day" }: { available: number; pending: number; unit?: "day" | "hour" }) {
  const i = useI18n();
  const total = Math.max(available + pending, 1);
  const scale = Math.max(14, Math.ceil(total / 7) * 7);
  return (
    <div className="balance">
      <p className="balance__figure">
        <span className="balance__n">{i.number(available)}</span>
        <span className="balance__unit">{unit === "day" ? "gün kullanılabilir" : "saat kullanılabilir"}</span>
      </p>
      {pending > 0 && <p className="balance__note">{i.amount(pending, unit)} onay bekleyen talebinize ayrıldı.</p>}
      {available < 0 && <p className="balance__note balance__note--neg">Bakiyeniz eksiye düşmüş; şirket politikası buna izin veriyor.</p>}
      <div className="balance__bar" aria-hidden="true">
        <span className="balance__fill" style={{ width: `${(Math.max(available, 0) / scale) * 100}%` }} />
        <span className="balance__pending" style={{ width: `${(pending / scale) * 100}%` }} />
      </div>
    </div>
  );
}
